import { gql } from '@apollo/client';

export const CREATE_PURCHASE = gql`
  mutation CreatePurchase($input: CreatePurchaseInput!) {
    createPurchase(input: $input) {
      id
      status
      totalAmount
      createdAt
      timeWindow
      buyingGroup {
        currentPrice
        basePrice
        discount
        buyerCount
      }
    }
  }
`;

export const CREATE_PAYMENT_INTENT = gql`
  mutation CreatePaymentIntent($purchaseId: ID!, $amount: Float!, $tokenReward: Int, $tokenRedemption: Int) {
    createPaymentIntent(purchaseId: $purchaseId, amount: $amount, tokenReward: $tokenReward, tokenRedemption: $tokenRedemption) {
      clientSecret
      paymentIntentId
      tokenDiscount
      feeBreakdown {
        subtotal
        platformFee
        logisticsFee
        tax
        total
      }
    }
  }
`;

export const CONFIRM_PAYMENT = gql`
  mutation ConfirmPayment($paymentIntentId: String!, $phone: String, $deliveryAddress: DeliveryAddressInput) {
    confirmPayment(paymentIntentId: $paymentIntentId, phone: $phone, deliveryAddress: $deliveryAddress) {
      success
      message
      purchase {
        id
        status
      }
      tokensEarned
      tokensRedeemed
      newAchievements {
        id
        name
        description
        icon
        tokens
      }
    }
  }
`;